import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import * as QueryParams from 'components/Explorer/models/query_params';

// Returns a navigation function for QueryParams state.
//   navigateParams(next)                              // same route, push
//   navigateParams(next, { replace: true })           // same route, replace
//   navigateParams(next, { pathname: '/mentions' })   // cross-route (drops page)
const useNavigateParams = () => {
  const navigate = useNavigate();
  return useCallback(
    (next, { pathname, replace = false } = {}) => {
      const location = pathname ? QueryParams.locationFor(next, pathname) : { search: QueryParams.searchFor(next) };
      navigate(location, { replace });
    },
    [navigate]
  );
};

export default useNavigateParams;
